import { InjectionKey } from "vue";
import { DragDropState } from "./useDragDrop";

export const dragDropInjectKey = Symbol() as InjectionKey<DragDropState>;
